// import styles from './custom.module.css';
// 설비 총개소 , 각 설비 상태에 따른 토탈 카운트 표시 컴포넌트 (대시보드 상단)
const MonitorUserStatCnt = ({statusCnt}) => {

  // console.log("statusCnt = ", statusCnt);
  return(
    <div className="uk-grid">
      <div className="uk-width-medium-1-5">
          <div className="md-card">
              <div className="md-card-content">
                  <table className="DAFiveT">
                      <tr>
                          <th>
                              총개소
                          </th>
                          <td>
                              {statusCnt.total}
                          </td>
                      </tr>
                  </table>
              </div>
          </div>
      </div>
      <div className="uk-width-medium-1-5">
          <div className="md-card">
              <div className="md-card-content">
                  <table className="DAFiveT">
                      <tr>
                          <th>
                              <img src="/images/chncareimg/icon_gre.png" alt="정상"/>&nbsp;&nbsp;정상
                          </th>
                          <td>
                            {statusCnt.normal}
                          </td>
                      </tr>
                  </table>
              </div>
          </div>
      </div>
      <div className="uk-width-medium-1-5">
          <div className="md-card">
              <div className="md-card-content">
                  <table className="DAFiveT">
                      <tr>
                          <th>
                              <img src="/images/chncareimg/icon_yl.png" alt="경고"/>&nbsp;&nbsp;경고
                          </th>
                          <td>
                            {statusCnt.warn}
                          </td>
                      </tr>
                  </table>
              </div>
          </div>
      </div>
      <div className="uk-width-medium-1-5">
          <div className="md-card">
              <div className="md-card-content">
                  <table className="DAFiveT">
                      <tr>
                          <th>
                              <img src="/images/chncareimg/icon_rd.png" alt="위험"/>&nbsp;&nbsp;위험
                          </th>
                          <td>
                            {statusCnt.danger}
                          </td>
                      </tr>
                  </table>
              </div>
          </div>
      </div>
      <div className="uk-width-medium-1-5">
          <div className="md-card">
              <div className="md-card-content">
                  <table className="DAFiveT">
                      <tr>
                          <th>
                              <img src="/images/chncareimg/icon_gray.png" alt="미작동"/>&nbsp;&nbsp;미작동
                          </th>
                          <td>
                            {statusCnt.unOper}
                          </td>
                      </tr>
                  </table>
              </div>
          </div>
      </div>

    </div>
  )
}

export default MonitorUserStatCnt;